<template>
    <SideNav ref="sidenav" :check-close="onCheckClose" class="edit-document-group">
        <div class="header">
            <div class="corner">
                <div class="corner-inner">
                    <div class="back" @click="$refs.sidenav.cancel()"></div>
                    <div class="title">{{ title }}</div>
                </div>
            </div>

            <div class="adhoc">
                <div class="adhoc-wrapper">
                    <div class="adhoc-content">
                        <div class="close" @click="$refs.sidenav.cancel()"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="middle">
            <div class="form-field required name">
                <div class="title">Название папки</div>
                <div class="value">
                    <input ref="name"
                           v-model="v.model.name.$model"
                           :class="{ error: v.model.name.$error }"
                           placeholder="Введите название"
                           type="text"
                    />
                </div>
            </div>

            <DocumentsAdd :can-edit="canEditAttachment"
                          :canRestore="true"
                          :max-file-size="0"
                          :otherFilesSize="otherFilesSize"
                          :documents.sync="model.documents"
                          calc-size-only-uploaded
            />
        </div>

        <div class="footer">
            <input class="ghost" type="button" value="Отмена" @click="close(null)" />
            <input :disabled="v.$invalid" :value="saveButtonText" class="primary save" type="button" @click="save" />
        </div>
    </SideNav>
</template>

<script>
import { DOCUMENT_STATE_EDIT } from '@/common/page_comp/Documents/document.states.js';
import DocumentGroup from '@/common/page_comp/Documents/documentGroup.js';
import { equals } from '@/common/util/util.js';
import { nameRulesDefault } from '@/common/util/validations/name.js';
import { useVuelidate } from '@vuelidate/core';

import DocumentsAdd from '@/common/page_comp/Documents/DocumentsAdd.vue';


const emptyModel = () => ({
    name: '',
    documents: [],
});

const documentsEditRule = (docs) => {
    if (!docs) return true;

    for (const it of docs) {
        if (it.removed)
            continue;

        if (it.state === DOCUMENT_STATE_EDIT)
            return false;
    }

    return true;
};


export default {
    name: 'EditDocumentGroup',
    props: {
        canEditAttachment: {
            type: Boolean,
            default: true,
        },
    },
    setup() {
        return {
            v: useVuelidate({ $stopPropagation: true }),
        };
    },
    components: {
        DocumentsAdd,
    },
    data() {
        return {
            model: emptyModel(),
            original: {},
            state: 'EDIT',

            otherFilesSize: 0,
        };
    },
    computed: {
        title() {
            return this.editState ? 'Редактирование папки' : 'Создание папки';
        },
        editState() {
            return this.state === 'EDIT';
        },
        saveButtonText() {
            return this.editState ? 'Сохранить' : 'Создать';
        },
        changed() {
            return !equals(this.model.name, this.original.value.name)
                || !equals(this.model.documents, this.original.value.documents);
        },
    },
    validations() {
        return {
            model: {
                name: {
                    ...nameRulesDefault(),
                },
                documents: {
                    $each: this.canEdit ? documentsEditRule : true,
                },
            },
        };
    },
    methods: {
        reset() {
            this.model = emptyModel();
            this.original = {};
            this.state = 'EDIT';
        },
        open(data = new DocumentGroup, otherFilesSize = 0) {
            this.reset();
            const newModel = Object.assign({}, emptyModel(), data.value);

            if (data.id == null && !newModel.name)
                this.state = 'CREATE';

            this.model = newModel;
            this.original = data;
            this.otherFilesSize = otherFilesSize;

            this.$nextTick(() => {
                this.$refs.name.focus();
            });

            return this.$refs.sidenav.open();
        },
        close(data) {
            this.$refs.sidenav.accept(data);
        },
        onCheckClose(sidenav) {
            if (!this.changed)
                return true;
            return sidenav.showConfirm();
        },
        save() {
            this.v.$touch();

            if (this.v.$invalid)
                return;

            const documents = this.model.documents.filter(it => !it.removed);
            this.original.value.name = this.model.name;
            this.original.addFiles(documents);

            this.close(this.original);
        },
    },
};
</script>

<style lang="scss" scoped>
.edit-document-group {

    .name {
        margin-bottom: 24px;
    }
}
</style>
